/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_Policy_Intro_P1_BInputs */

const es_privacy_policy_intro_p1_b = /** @type {(inputs: Privacy_Policy_Intro_P1_BInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`(actualmente operando como empresa individual en Argentina, con planes de constituirse como LLC en los Estados Unidos en el futuro cercano).`)
};

const en_privacy_policy_intro_p1_b = /** @type {(inputs: Privacy_Policy_Intro_P1_BInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`(currently operating as a sole proprietorship in Argentina, with plans to incorporate as an LLC in the United States in the near future).`)
};

/**
* | output |
* | --- |
* | "(currently operating as a sole proprietorship in Argentina, with plans to incorporate as an LLC in the United States in the near future)." |
*
* @param {Privacy_Policy_Intro_P1_BInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const privacy_policy_intro_p1_b = /** @type {((inputs?: Privacy_Policy_Intro_P1_BInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_Policy_Intro_P1_BInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_privacy_policy_intro_p1_b(inputs)
	return en_privacy_policy_intro_p1_b(inputs)
});
export { privacy_policy_intro_p1_b as "privacy_policy.intro.p1_b" }